/** A navy phone outline around a card preview. */
export default function PhoneFrame({ children }) {
  return (
    <div className="bg-navy rounded-[36px] p-3 max-w-[380px] mx-auto shadow-xl">
      <div className="bg-white rounded-[26px] overflow-hidden">{children}</div>
    </div>
  );
}
